const principles = [
  {
    icon: "ri-search-eye-line",
    title: "求证为先",
    desc: "每条内容尽量提供可追踪的信源，未经证实的消息会明确标注，拒绝未经核实就下结论。",
  },
  {
    icon: "ri-shuffle-line",
    title: "多信源交叉",
    desc: "同一件事尽量比对多方口径，把时间线与疑点整理清楚，还原一个更接近全貌的现场。",
  },
  {
    icon: "ri-hand-heart-line",
    title: "吃瓜有度",
    desc: "关注事件本身而非情绪狂欢，不传播谣言、不引导网暴，做清醒而克制的围观者。",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid items-start gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-bold text-secondary-900">
              <i className="ri-user-heart-line" aria-hidden="true"></i>关于我们
            </span>
            <h2 className="mt-3 text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              我们为什么做「吃瓜爆网」
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              互联网的热点来去太快。昨晚还霸屏的话题，今天可能就被新的瓜顶了下去。吃瓜爆网想做的是
              一台"热点收拢机"：把散落在各个平台的今日炸点、爆点事件与全网围观话题聚到一处，
              用统一的栏目和榜单帮你快速定位正在发生的事，省去来回翻找的力气。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              我们不制造冲突，也不贩卖焦虑。我们相信，围观本身没有错，错的是不分真假的跟风。
              正因如此，我们始终坚持把「求证」放在「传播」之前。
            </p>

            <h3 className="mt-8 flex items-center gap-2 text-base font-bold text-foreground-950">
              <i className="ri-shield-check-line text-primary-600" aria-hidden="true"></i>内容三大原则
            </h3>
            <div className="mt-4 flex flex-col gap-3">
              {principles.map((p) => (
                <div key={p.title} className="flex items-start gap-4 rounded-xl border border-background-200 bg-background-50 p-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent-100 text-accent-800">
                    <i className={`${p.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-950">{p.title}</p>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-5">
            <div className="overflow-hidden rounded-2xl border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20in%20warm%20coral%20red%20amber%20and%20cream%20palette%2C%20a%20team%20of%20reporters%20around%20a%20large%20watermelon%20sorting%20and%20curating%20news%20cards%20with%20magnifying%20glass%20and%20documents%2C%20watermelon%20melon%20motif%2C%20media%20editorial%20team%20theme%2C%20clean%20minimal%20vector%20art%2C%20no%20text&width=1000&height=720&seq=about-visual-x1&orientation=landscape"
                alt="吃瓜爆网编辑部选题编审插画"
                className="h-56 w-full object-cover md:h-64"
              />
            </div>

            <div className="rounded-2xl border border-background-200 bg-primary-900 p-6 text-background-100 md:p-7">
              <h3 className="flex items-center gap-2 text-base font-bold text-background-50">
                <i className="ri-upload-2-line text-accent-300" aria-hidden="true"></i>投稿与联系
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-background-200">
                有独家线索或想聊的选题？欢迎来信，我们会认真对待每一封投稿，并在核验后尽快回复。
              </p>
              <a
                href="mailto:contact@chigua-baowang.example.com"
                className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-400"
              >
                <i className="ri-mail-line" aria-hidden="true"></i>contact@chigua-baowang.example.com
              </a>
              <div className="mt-5 flex items-center gap-3 border-t border-primary-800 pt-4 text-xs text-background-300">
                <span className="flex items-center gap-1.5">
                  <i className="ri-time-line text-accent-300" aria-hidden="true"></i>每日滚动更新
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-refresh-line text-accent-300" aria-hidden="true"></i>榜单每小时刷新
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}